import aiAssistantStates from '../../../consts/aiAssistant/aiAssistantStates';
import {strCode} from '../../../consts/strCode';
import {CrossFade} from '../../CrossFade/CrossFade';
import AiAssistantLoaderIcon from '../../Icons/AiAssistantIcons/AiAssistantLoaderIcon';
import AiAssistantWaveformIcon from '../../Icons/AiAssistantIcons/AiAssistantWaveformIcon';
import AiAssistantWidgetText from '../AiAssistantWidgetText';

const ICON_KEYS = {
    DEFAULT: 'default',
    THINKING: 'thinking',
};

// Same loader in both layers: the spin starts from the paused pose, so the swap is invisible
const ICON_LAYERS = {
    [ICON_KEYS.DEFAULT]: <AiAssistantLoaderIcon className='h-12 w-12' isAnimating={false} />,
    [ICON_KEYS.THINKING]: <AiAssistantLoaderIcon className='h-12 w-12' />,
};

const ICON_KEY_BY_STATE = {
    [aiAssistantStates.IDLE]: ICON_KEYS.DEFAULT,
    [aiAssistantStates.LISTENING]: ICON_KEYS.DEFAULT,
    [aiAssistantStates.THINKING]: ICON_KEYS.THINKING,
    [aiAssistantStates.SPEAKING]: ICON_KEYS.DEFAULT,
    [aiAssistantStates.WAITING]: ICON_KEYS.THINKING,
};

const CAPTION_KEYS = {
    IDLE: 'idle',
    WAVEFORM: 'waveform',
    THINKING: 'thinking',
    WAITING: 'waiting',
};

// One key for LISTENING and SPEAKING, so switching between them doesn't remount and restart the wave
const CAPTION_KEY_BY_STATE = {
    [aiAssistantStates.IDLE]: CAPTION_KEYS.IDLE,
    [aiAssistantStates.LISTENING]: CAPTION_KEYS.WAVEFORM,
    [aiAssistantStates.THINKING]: CAPTION_KEYS.THINKING,
    [aiAssistantStates.SPEAKING]: CAPTION_KEYS.WAVEFORM,
    [aiAssistantStates.WAITING]: CAPTION_KEYS.WAITING,
};

const caption = (captionStrCode) => <AiAssistantWidgetText strCode={captionStrCode} className='text-center' />;

const CAPTION_LAYERS = {
    [CAPTION_KEYS.IDLE]: caption(strCode.AI_ASSISTANT_ASK_ANYTHING_PLACEHOLDER),
    [CAPTION_KEYS.WAVEFORM]: <AiAssistantWaveformIcon className='h-auto max-w-full' />,
    [CAPTION_KEYS.THINKING]: caption(strCode.AI_ASSISTANT_THINKING_PLACEHOLDER),
    [CAPTION_KEYS.WAITING]: caption(strCode.AI_ASSISTANT_WAITING_CONFIRMATION_PLACEHOLDER),
};

const AiAssistantWidgetConversation = ({assistantState}) => (
    <div className='flex h-[90px] shrink-0 items-center'>
        <CrossFade
            activeKey={ICON_KEY_BY_STATE[assistantState]}
            className='relative h-12 w-12 shrink-0'
            layerClassName='flex items-center justify-center'
            layers={ICON_LAYERS}
        />

        <CrossFade
            activeKey={CAPTION_KEY_BY_STATE[assistantState]}
            className='relative flex-1'
            layerClassName='flex min-w-0 items-center justify-center'
            layers={CAPTION_LAYERS}
        />
    </div>
);

export default AiAssistantWidgetConversation;
